import React from "react";

function FilterInputCheckbox({ filter, onChange }) {
  function onInputChange() {
    const changedFilter = {
      ...filter,
      selected: !filter.selected,
    };
    onChange(changedFilter);
  }
  return (
    <div className="tag">
      <input
        type="checkbox"
        id={filter.name}
        disabled={!filter?.available}
        onChange={onInputChange}
        checked={filter?.selected ? true : false}
      />
      <label htmlFor={filter.name}>{filter.name}</label>
    </div>
  );
}

export default FilterInputCheckbox;
